import './NewTemplateModal.scss';

export { default } from './NewTemplateModal';
